var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 12,
    fill: "none",
    viewBox: "0 0 36 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF4B55",
    d: "M36 0H0v23.992h36V-.001Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE15A",
    d: "M36 5.997H0v11.997h36V5.997Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4B55",
    d: "M11 12.53a.5.5 0 0 0-.5-.5H9v-1.5a.499.499 0 0 0-.5-.5H6v2.5a.499.499 0 0 0 .5.5H8v2a.5.5 0 0 0 .5.5 2.5 2.5 0 0 0 2.5-2.5v-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FD823D",
    d: "M8.5 12.5H6v.5a2.5 2.5 0 0 0 2.5 2.5v-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M4 10.109h1v5.502H4v-5.502ZM12 10.109h1v5.502h-1v-5.502ZM8.5 10H11V12.5H8.5V10Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FD823D",
    d: "M11 8.5H6a1 1 0 0 0 .999 1H10a1 1 0 0 0 1-1Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h36v23.995H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEs);
export default __webpack_public_path__ + "static/media/es.ba4d48882312af3d0f7683e024bfbd15.svg";
export { ForwardRef as ReactComponent };